/**
 * Constants for the dimensions of the WebCam code. Quality is technically a dimension, and I don't feel like coming
 * up with another name.
 */

export const PREVIEW_WIDTH     = 640;
export const PREVIEW_HEIGHT    = 480;
export const INPUT_WIDTH       = 480;
export const INPUT_HEIGHT      = 480;
export const IMAGE_QUALITY     = .9; // Value between 0 and 1
export const SCREENSHOT_FORMAT = 'image/jpeg';
